import { UpdateIcon } from '@radix-ui/react-icons';

export default function CgBlockLoader() {
  return (
    <div className="min-h-full">
      <div className="absolute z-10 top-0 left-0 h-full w-full backdrop-blur-[3px] bg-white/30 flex flex-col justify-center items-center text-gray-400">
        <UpdateIcon className="w-12 h-12 animate-spin text-primaryColor" />
      </div>
    </div>
  );
}
